export const characterLoad = "characterload";
export const characterAdd = "characteradd";
export const characterLoadLocal = "characterloadlocal";
